// 현재 플레이 모드를 감지합니다.
// MODE A: Zero to One (창업 시뮬레이션)
// MODE B: Plug & Play (신입 입사, AI CEO)

export type PlayMode = "A" | "B" | null;

export function getPlayMode(): PlayMode {
  const raw = localStorage.getItem("kap_play_mode");
  if (raw === "A" || raw === "B") return raw;
  return null;
}

export function isPlugAndPlay(): boolean {
  return getPlayMode() === "B";
}

export function usePlayMode() {
  const mode = getPlayMode();
  return {
    mode,
    isPlugAndPlay: mode === "B",
    isZeroToOne: mode === "A",
  };
}
